import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, ICenterCLCTargetedPairsResponse } from '@nkr/store/index';
import { IUser } from '@nkr/models/index';
import CenterCLCTargedPairsGrid from './center-cls-targeted-pairs-grid';
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps { }

interface IStateProps {
    user: IUser,
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCenterCLCTargetedPairsReport: () => Promise<ICenterCLCTargetedPairsResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

class CenterCLCTargetedPairsReport extends React.Component<TProps, {}> {
    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (event: GridReadyEvent) => {
        this.gridApi = event.api;
        this.gridColumnApi = event.columnApi;
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: `clc-targeted-pairs.csv`,
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.colId == 'centerAlias') {
                    if (params.node.data.centerAlias == '') {
                        return 'Totals';
                    }
                }

                return params.value;
            }
        };

        this.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        return (
            <>
                <CenterCLCTargedPairsGrid
                    getCenterCLCTargetedPairsReport={this.props.getCenterCLCTargetedPairsReport}
                    showLoading={this.props.showLoading}
                    hideLoading={this.props.hideLoading}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        user: appState.app.user,
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getCenterCLCTargetedPairsReport: () => {
            return dispatch(ReportActionCreators.getCenterCLCTargetedPairsReport());
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterCLCTargetedPairsReport);